import { render, staticRenderFns } from "./invoiceRecordDetailOrder.vue?vue&type=template&id=2debf67a&scoped=true&"
import script from "./invoiceRecordDetailOrder.vue?vue&type=script&lang=js&"
export * from "./invoiceRecordDetailOrder.vue?vue&type=script&lang=js&"
import style0 from "./invoiceRecordDetailOrder.vue?vue&type=style&index=0&id=2debf67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2debf67a",
  null
  
)

export default component.exports